module.exports = __webpack_public_path__ + "img/tz.09d6369c.svg";